const pages = [
  {
    groupTitle: 'Getting Started',
    id: 'getting-started',
    pages: [
      {
        title: 'Introduction',
        href: '/docs/introduction',
      },
      {
        title: 'Initial Setup',
        href: '/docs/setup',
      },
      {
        title: 'Quick Start (React Scripts)',
        href: '/docs/quick-start-react-scripts',
      },
      {
        title: 'Quick Start (NextJS)',
        href: '/docs/quick-start-nextjs',
      },
      {
        title: 'Quick Start (GatsbyJS)',
        href: '/docs/quick-start-gatsbyjs',
      },
      {
        title: 'MUI',
        href: 'https://mui.com/',
        target: '_blank',
      },
    ],
  },
  {
    groupTitle: 'Theme UI',
    id: 'theme-ui',
    pages: [
      {
        title: 'Colors',
        href: '/docs/colors',
      },
      {
        title: 'Typography',
        href: '/docs/typography',
      },
      {
        title: 'Shadows',
        href: '/docs/shadows',
      },
      {
        title: 'Page',
        href: '/docs/page',
      },
      {
        title: 'Container',
        href: '/docs/container',
      },
      {
        title: 'Layouts',
        href: '/docs/layouts',
      },
      {
        title: 'Icons',
        href: '/docs/icons',
      },
      {
        title: 'Illustrations',
        href: '/docs/illustrations',
      },
      {
        title: 'Components',
        href: '/blocks',
      },
      {
        title: 'Demo Pages',
        href: '/demos',
      },
      {
        title: 'MUI Components',
        href: 'https://mui.com/components/box/',
        target: '_blank',
      },
    ],
  },
  {
    groupTitle: 'Plugins',
    id: 'plugins',
    pages: [
      {
        title: 'AOS Animate',
        href: 'https://michalsnik.github.io/aos/',
        target: '_blank',
      },
      {
        title: 'Formik React Forms',
        href: 'https://formik.org/',
        target: '_blank',
      },
      {
        title: 'React Count Up',
        href: 'https://www.npmjs.com/package/react-countup',
        target: '_blank',
      },
      {
        title: 'Images Carousel and Modals',
        href: 'https://www.npmjs.com/package/react-image-lightbox',
        target: '_blank',
      },
      {
        title: 'Image Lazy Loading',
        href: 'https://www.npmjs.com/package/react-lazy-load-image-component',
        target: '_blank',
      },
      {
        title: 'Image Swiper',
        href: 'https://react-slick.neostack.com/',
        target: '_blank',
      },
      {
        title: 'Typed Text',
        href: 'https://www.npmjs.com/package/react-typed',
        target: '_blank',
      },
      {
        title: 'Visibility Sensor',
        href: 'https://www.npmjs.com/package/react-visibility-sensor',
        target: '_blank',
      },
      {
        title: 'Jarallax',
        href: 'https://www.npmjs.com/package/jarallax',
        target: '_blank',
      },
    ],
  },
  {
    groupTitle: 'Support & Change Log',
    id: 'support-change-log',
    pages: [
      {
        title: 'Support',
        href: '/docs/support',
      },
      {
        title: 'Change Log (v4.6.0)',
        href: '/docs/change-log',
      },
    ],
  },
];

export default pages;
